module.exports = __webpack_public_path__ + "img/pageot.a4b76a7e.jpeg";